<form [formGroup]="dateForm" *transloco="let t; read 'prices.upsert_price'" class="flex gap-2">
  <psc-select
    class="basis-2/3"
    formControlName="month"
    [label]="t('date_picker.month')"
    [options]="months"></psc-select>
  <psc-select
    class="basis-1/3"
    formControlName="date"
    [label]="t('date_picker.date')"
    [options]="dates"></psc-select>
</form>
